var swiper = new Swiper.default('.slider', {
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  },
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  longSwipesRatio: 0.3,
  autoplay: {
    delay: 4000,
  }

});

$(".featured-slider").each(function(ind, val) {

  var countSlides = $(val).find(".swiper-slide").length;

  var featured = new Swiper.default(val, {
    loop: countSlides > 4,
    slidesPerView: 4,
    slidesPerGroup: 4,
    watchOverflow: true,
    navigation: {
      nextEl: '.swiper-button-next--featured',
      prevEl: '.swiper-button-prev--featured'
    },
    autoplay: {
      delay: 2000,
    },
    longSwipesRatio: 0.3, 
    breakpoints: {

      640: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: countSlides > 1,
      },
      // when window width is <= 480px
      900: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        loop: countSlides > 2,
      },
      // when window width is <= 640px
      1200: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        loop: countSlides > 3,
      }
    }

  });
  
  $(val).mouseover(function(){
    featured.autoplay.stop();	
  });

  $(val).mouseleave(function(){
    featured.autoplay.start();	
  });
});


// var brands = new Swiper.default('.brands-slider', {
//   loop: true,
//   slidesPerView: 'auto',
//   loopedSlides: -23,
//   navigation: {
//     nextEl: '.swiper-button-next--brands-slider',
//     prevEl: '.swiper-button-prev--brands-slider'
//   },
//   autoplay: {
//     delay: 2000,
//   },
//   centeredSlides: false,

// });

$(".brands-slider").each(function(ind, val) {

  var countSlides = $(val).find(".swiper-slide").length;

  var brands = new Swiper.default('.brands-slider', {
    loop: countSlides > 6,
    slidesPerView: 'auto',
    loopedSlides: countSlides - 7,
    navigation: {
      nextEl: '.swiper-button-next--brands-slider',
      prevEl: '.swiper-button-prev--brands-slider'
    },
    autoplay: {
      delay: 2000,
    },
    centeredSlides: false,

  });

});
